import './index.less';
import * as React from 'react';
import { Link } from 'react-router-dom';

const styles = require('./index.less');

const BackHomeLink = ({ to }) => (
  <Link className={styles.root} to={to} data-name="返回首页">
    {'<返回'}
  </Link>
);

export default BackHomeLink;
